import { Row, Typography } from '@tempmee/react';
import { SolidExclamationWarningAlertIcon } from '@tempmee/react-icons';
import { colors } from '@tempmee/tailwind';

export const CardTitle = ({ name, showWarningIcon }) => (
  <Row data-testid="card-title" gap={2} align="center">
    <Typography bold color={colors.primary['500']} size="body_large">
      {name}
    </Typography>
    {showWarningIcon && (
      <SolidExclamationWarningAlertIcon width={20} height={20} color={colors.warning['500']} />
    )}
  </Row>
);
